import type { ActionType } from 'typesafe-actions';

import type { Notification } from '@portal/api-models';

import type * as actions from './actions';

export type NotificationAction = ActionType<typeof actions>;

export enum NotificationFilter {
  ALL = 'all',
  UNREAD = 'unread',
}

export interface NotificationState {
  drawerVisible: boolean;
  filter: NotificationFilter;
  rows: Notification[];
}
